'use client'

import AudioVisualizer from '@components/primitives/AudioVisualizer/index.client'
import { Icon } from '@components/primitives/Icon'
import { CloudflareImage } from '@components/primitives/Image/Cloudflare'
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser'
import { faWaveform } from '@fortawesome/pro-solid-svg-icons/faWaveform'

export function LiveAIAgent({
  mediaRecorder,
  patientName,
}: {
  mediaRecorder?: MediaRecorder
  patientName?: string
}) {
  return (
    <div className='z-10 flex flex-col'>
      <div className='flex flex-row items-center gap-1'>
        {mediaRecorder ? (
          <AudioVisualizer
            height={64}
            mediaRecorderInstance={mediaRecorder}
            width={128}
          />
        ) : (
          <div className='flex h-16 w-32 items-center justify-center rounded-sm bg-primary200'>
            <Icon
              className='h-12 animate-pulse text-primary600'
              icon={faWaveform}
              size='4x'
            />
          </div>
        )}
        <CloudflareImage
          alt={`Ai Agent Preview`}
          className='size-16 rounded-full border-2 border-white'
          height={300}
          imageId={'d07c4b92-a144-4701-def7-79e150770100'}
          width={300}
        />
        <div className='-ml-4 flex size-16 items-center justify-center rounded-full border-2 border-white bg-neutral400'>
          <Icon className='text-white' icon={faUser} size='2x' />
        </div>
        <div className='flex flex-col items-start gap-0'>
          <div className='text-sm font-medium uppercase'>Live Agent</div>
          <div className='text-lg font-bold'>{patientName ?? 'Patient'}</div>
        </div>
      </div>
    </div>
  )
}
